<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
  <path stroke="currentColor" stroke-linecap="round" stroke-width="4.267" d="M24.187 9.163a10.667 10.667 0 10-13.65 15.998"/>
  <mask id="a" width="20" height="10" x="7" y="20" style="mask-type:alpha" maskUnits="userSpaceOnUse">
    <path stroke="url(#paint0_linear)" stroke-linecap="round" stroke-width="5.333" d="M10.537 25.161A10.666 10.666 0 0024.04 23.01"/>
  </mask>
  <g mask="url(#a)">
    <path stroke="currentColor" stroke-linecap="round" stroke-width="4.267" d="M26.667 16a10.667 10.667 0 10-2.627 7.01"/>
  </g>
  <defs>
    <linearGradient id="paint0_linear" x1="13.067" x2="25.6" y1="26.133" y2="22.133" gradientUnits="userSpaceOnUse">
      <stop/>
      <stop offset="1" stop-opacity="0"/>
    </linearGradient>
  </defs>
</svg>